module.exports = __webpack_public_path__ + "static/media/banner.82de02b6.svg";